import apiClient from 'src/api/util/apiClient'

export default apiClient(process.env.REACT_APP_MIKASA_URI)
